/* istanbul ignore file */

import React from 'react';

import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { SkeletonRectangle } from '@lumapps/lumx/react';

export const loadBlockStructuredContent = () =>
    import(
        /* webpackChunkName: 'block-structured-content' */
        './BlockStructuredContent'
    );

const LazyBlockStructuredContent = React.lazy(loadBlockStructuredContent);

export const BlockStructuredContent: React.FC<React.ComponentProps<typeof LazyBlockStructuredContent>> = (props) => (
    <Suspense loadingFallback={<SkeletonRectangle style={{ height: '100vh' }} />}>
        <LazyBlockStructuredContent {...props} />
    </Suspense>
);
